import { scrollToElement } from '@99designs/browser';
import { Button, Card, Heading, Stack } from '@99designs/emu';
import { FormattedMessage } from '@99designs/frontend-components/i18n';
import { IconDown4 } from '@99designs/icons';
import { FeaturesList } from '@99designs/marketing-ui';
import { Price } from '@99designs/marketing-ui';
import StarRatings from '../Rating/StarRatings';
import { STICKY_BAR_HEIGHT_PX } from '../StickyBar';
import { DEFAULT_SCROLL_OFFSET_PX, TabId } from '../TabsMenu';
import type { Price as PriceType } from '../../types';

type Props = {
    title: string;
    price: PriceType;
    inclusions: string[];
    showRating?: boolean;
};

export function ProductGroupPreview({ title, price, inclusions, showRating }: Props) {
    const handleScrollClick = () => {
        const element = document.getElementById(TabId.ProductComparison);
        if (element) {
            // We assume that sticky bar is always shown when scrolled to pricing
            scrollToElement(element, STICKY_BAR_HEIGHT_PX + DEFAULT_SCROLL_OFFSET_PX);
        }
    };

    return (
        <Card padding="2bu">
            <Stack space="1.5bu">
                <Heading appearanceLevel={3} accessibilityLevel={1}>
                    {title}
                </Heading>
                {showRating && <StarRatings />}
                <Heading appearanceLevel={5} accessibilityLevel={2} as="p">
                    <FormattedMessage
                        message={__('Starting from {price}')}
                        values={{
                            price: <Price amount={price.amountInCents} currency={price.currency} />,
                        }}
                    />
                </Heading>
                {inclusions.length > 0 && <FeaturesList features={inclusions} />}
                <Button
                    icon={{ component: IconDown4, position: 'right' }}
                    width="fill"
                    onClick={handleScrollClick}
                >
                    {__('Select a package')}
                </Button>
            </Stack>
        </Card>
    );
}
